import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 8v8","key":"svg-1"}],["path",{"d":"M14 8l-2.5 4l2.5 4","key":"svg-2"}],["path",{"d":"M10 12h1.5","key":"svg-3"}]]

const IconCircleLetterK = createReactComponent('outline', 'circle-letter-k', 'CircleLetterK', __iconNode);

export default IconCircleLetterK;